export const toggleNavBar = () => ({
  type: 'TOGGLE_NAVBAR'
})